{
  "+KgYMC": [
    {
      "type": 0,
      "value": "Något gick fel"
    }
  ],
  "+Z5RUs": [
    {
      "type": 0,
      "value": "”"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Allmänna villkor"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "” betyder dessa allmänna villkor för veterinärtjänster enligt dess senaste lydelse."
    }
  ],
  "+itf/D": [
    {
      "type": 0,
      "value": "Spara"
    }
  ],
  "+oxz7i": [
    {
      "type": 0,
      "value": "Från "
    },
    {
      "type": 1,
      "value": "price"
    }
  ],
  "/vhYnT": [
    {
      "type": 0,
      "value": "Anteckningar till kliniken"
    }
  ],
  "/yc/w7": [
    {
      "type": 0,
      "value": "Vi har upptäckt att flera profiler är kopplade till ditt personnummer, vilket gör att du inte kan boka besök online."
    }
  ],
  "03+aWo": [
    {
      "type": 0,
      "value": "Sammanfattning"
    }
  ],
  "0nJ1MV": [
    {
      "type": 0,
      "value": "Postnummer"
    }
  ],
  "1UG0k5": [
    {
      "type": 0,
      "value": "Morgon"
    }
  ],
  "1bZ2OG": [
    {
      "type": 0,
      "value": "Senast besökta"
    }
  ],
  "295JUa": [
    {
      "type": 0,
      "value": "E-postadressen du angav är inte giltig"
    }
  ],
  "3QGdyf": [
    {
      "type": 0,
      "value": "Välj klinik"
    }
  ],
  "3Wcqsy": [
    {
      "type": 0,
      "value": "Nästa"
    }
  ],
  "4BH2f8": [
    {
      "type": 0,
      "value": "Stäng"
    }
  ],
  "4Bsy75": [
    {
      "type": 0,
      "value": "Har du inte BankID?"
    },
    {
      "type": 1,
      "value": "br"
    },
    {
      "type": 0,
      "value": "Vänligen kontakta oss på "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "clinicPhoneNumber"
        }
      ],
      "type": 8,
      "value": "clinicPhoneNumberText"
    },
    {
      "type": 0,
      "value": " för att boka."
    }
  ],
  "4QxoQn": [
    {
      "children": [
        {
          "type": 0,
          "value": "Allmänt"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": Evidensia ska i den mån det är möjligt anteckna omfattningen av den Sjukvårdande behandlingen i journalen. Om Evidensia upptäcker efter Inskrivningen att det krävs någon annan omfattning av den Sjukvårdande behandlingen ska detta antecknas i journalen och Djurägaren ska så snart det kan ske informeras om detta. Vid akut eller livshotande tillstånd hos djuret behöver omfattningen av den Sjukvårdande behandlingen inte antecknas i journalen förrän efter att den Sjukvårdande behandlingen utförts. Evidensia har alltid rätt att, helt eller delvis och utan motivering, avböja att utföra Sjukvårdande behandling."
    }
  ],
  "5VPo0E": [
    {
      "type": 0,
      "value": "Namn"
    }
  ],
  "7Vk55F": [
    {
      "type": 0,
      "value": "Adress"
    }
  ],
  "7u0nhU": [
    {
      "type": 0,
      "value": "Jag har läst och godkänner de "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "allmänna villkoren"
        }
      ],
      "type": 8,
      "value": "tclink"
    },
    {
      "type": 0,
      "value": " samt tagit del av "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "personuppgiftspolicyn"
        }
      ],
      "type": 8,
      "value": "pplink"
    }
  ],
  "7wz3H0": [
    {
      "type": 0,
      "value": "Är du säker på att du vill logga ut?"
    }
  ],
  "8faccV": [
    {
      "type": 0,
      "value": "Visa detaljer"
    }
  ],
  "8isYGV": [
    {
      "type": 0,
      "value": "Fortsätt"
    }
  ],
  "8pRmsV": [
    {
      "type": 0,
      "value": "Godkännande av allmänna villkor för hästar"
    }
  ],
  "8rOQmk": [
    {
      "type": 0,
      "value": "Manlig"
    }
  ],
  "95SGnw": [
    {
      "type": 0,
      "value": "Kvinnlig"
    }
  ],
  "9ayVdY": [
    {
      "type": 0,
      "value": "”"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Inskrivning"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "” betyder det förfarande genom vilket Hästägaren/Beställaren registrerar sin häst hos Evidensia i anslutning till den Sjukvårdande behandlingen"
    }
  ],
  "9biY42": [
    {
      "type": 0,
      "value": "Tack för din bokning"
    }
  ],
  "9gOiO+": [
    {
      "type": 0,
      "value": "Namnet är obligatoriskt"
    }
  ],
  "9hKhyZ": [
    {
      "type": 0,
      "value": "Försök igen"
    }
  ],
  "A4Bx7L": [
    {
      "children": [
        {
          "type": 0,
          "value": "Allmänt"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": Evidensia ska i den mån det är möjligt anteckna omfattningen av den Sjukvårdande behandlingen i journalen. Om Evidensia upptäcker efter Inskrivningen att det krävs någon annan omfattning av den Sjukvårdande behandlingen ska detta antecknas i journalen och Beställaren ska så snart det kan ske informeras om detta. Vid akut eller livshotande tillstånd hos hästen behöver omfattningen av den Sjukvårdande behandlingen inte antecknas i journalen förrän efter att den Sjukvårdande behandlingen utförts. Evidensia har alltid rätt att, helt eller delvis och utan motivering, avböja att utföra Sjukvårdande behandling."
    }
  ],
  "AoLGJ0": [
    {
      "type": 0,
      "value": "Kontaktuppgifter"
    }
  ],
  "AtemAW": [
    {
      "type": 0,
      "value": "Välj tjänst"
    }
  ],
  "BPmCSe": [
    {
      "type": 0,
      "value": "Välj detta alternativ för att se alla tillgängliga tider"
    }
  ],
  "BqUf8Z": [
    {
      "type": 0,
      "value": "Kastrerad:"
    }
  ],
  "Bs6GJB": [
    {
      "type": 0,
      "value": "Försök igen!"
    }
  ],
  "C3dd3n": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "C7GCQ3": [
    {
      "type": 0,
      "value": "Ras"
    }
  ],
  "CariJR": [
    {
      "type": 0,
      "value": "FÖRSÖK IGEN"
    }
  ],
  "CyniKP": [
    {
      "type": 0,
      "value": "Godkänt"
    }
  ],
  "D6szQG": [
    {
      "type": 0,
      "value": "Försök igen!"
    }
  ],
  "D7qbEN": [
    {
      "type": 0,
      "value": "Testa TOS-samtyckesskärm."
    }
  ],
  "DWtSWO": [
    {
      "type": 0,
      "value": "Mobil"
    }
  ],
  "DuyxVu": [
    {
      "type": 0,
      "value": "Om ditt djur tillhör en annan djurart, vänligen kontakta oss på "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "clinicPhoneNumber"
        }
      ],
      "type": 8,
      "value": "clinicPhoneNumberText"
    },
    {
      "type": 0,
      "value": " för att boka."
    }
  ],
  "E3FP8J": [
    {
      "type": 0,
      "value": "Mina djur"
    }
  ],
  "E71+2H": [
    {
      "type": 0,
      "value": "Försök igen!"
    }
  ],
  "EMGu+t": [
    {
      "type": 0,
      "value": "Det gick inte att godkänna villkoren. Försök igen eller återkom vid senare tillfälle."
    }
  ],
  "EpI0mc": [
    {
      "children": [
        {
          "type": 0,
          "value": "Besiktning"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": Om den Sjukvårdande behandlingen utgörs av besiktning av hästens status, hälsa eller därmed jämförbart tillstånd ska Evidensia i samband med Inskrivningen anteckna syftet med besiktningen. Syftet kommer vara avgörande för nivån och omfattningen av besiktningen. Hästägaren/Beställaren är medveten om att en besiktning alltid utgör en ögonblicksbedömning och en subjektiv värdering."
    }
  ],
  "Exb2ky": [
    {
      "type": 0,
      "value": "Bekräfta bokningen"
    }
  ],
  "ExmxoP": [
    {
      "children": [
        {
          "type": 0,
          "value": "Allmänt"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": Evidensia ersätter Hästägaren/Beställaren endast för skada som orsakats av vårdslöshet eller försummelse vid utförandet av den Sjukvårdande behandlingen, dock inte indirekt skada. Evidensia ersätter inte förlust, skada eller utebliven vinst i näringsverksamhet. Ersättning enligt ovan betalas med ett högsta belopp om ett (1) prisbasbelopp (vid var tid gällande enligt socialförsäkringsbalken), om inte något annat anges i dessa Allmänna villkor eller i besiktningsintyget för häst."
    }
  ],
  "F0qtSP": [
    {
      "type": 0,
      "value": "”"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Djurägaren"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "” betyder en person som är minst 18 år och som äger eller har ansvar (som ombud för ägaren) för djuret som den Sjukvårdande behandlingen avser."
    }
  ],
  "FCesIR": [
    {
      "type": 0,
      "value": "Adress"
    }
  ],
  "FbCJFI": [
    {
      "type": 0,
      "value": "Något gick fel"
    }
  ],
  "FtPNTU": [
    {
      "type": 0,
      "value": "Uppdatera din adress"
    }
  ],
  "G+7O+o": [
    {
      "type": 0,
      "value": "Se aktuellt pris på vår hemsida under \"Priser\"."
    }
  ],
  "G8WqPE": [
    {
      "type": 0,
      "value": "Nej, ingen preferens"
    }
  ],
  "GAG4kM": [
    {
      "type": 0,
      "value": "Uppdatera mobilnummer"
    }
  ],
  "GoWwI6": [
    {
      "type": 0,
      "value": "E-post krävs"
    }
  ],
  "H3OeAm": [
    {
      "type": 0,
      "value": "Mina husdjur"
    }
  ],
  "H8W9dk": [
    {
      "type": 0,
      "value": "”"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Sjukvårdande behandling"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "” betyder varje åtgärd som vidtas för att medicinskt förebygga, påvisa, lindra eller bota sjukdom, skada eller därmed jämförligt tillstånd hos djur; åtgärder för att utföra operativa ingrepp på eller ge injektioner till djur i annat fall; inklusive, men inte begränsat till, besiktningar av och utlåtanden om djurs status, hälsa eller därmed jämförbart tillstånd."
    }
  ],
  "HUMlR3": [
    {
      "type": 0,
      "value": "Välj detta alternativ om du vill träffa en specifik vårdgivare. Observera att tillgängligheten kan vara begränsad."
    }
  ],
  "HYP1NC": [
    {
      "type": 0,
      "value": "Något gick fel"
    }
  ],
  "HZxi+1": [
    {
      "type": 0,
      "value": "”"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Dotterbolag"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "” betyder ett bolag (i) som direkt eller indirekt kontrollerar Evidensia; (ii) som är under samma direkta eller indirekta ägande eller kontroll som Evidensia; eller (iii) som direkt eller indirekt ägs eller kontrolleras av Evidensia. I det här sammanhanget ska ett bolag anses vara kontrollerat av någon annan om det andra bolaget äger mer än femtio procent (>50%) av rösterna i ett sådant bolag, kan styra bolagets angelägenheter eller kontrollera styrelsens, eller motsvarande organs, sammansättning av styrelseledamöter eller motsvarande."
    }
  ],
  "Hp/8ql": [
    {
      "type": 0,
      "value": "Ok stäng"
    }
  ],
  "I2osjB": [
    {
      "type": 0,
      "value": "Ange namnet på ditt djur."
    }
  ],
  "IS8Z03": [
    {
      "type": 0,
      "value": "Nej"
    }
  ],
  "Ix5QgD": [
    {
      "type": 0,
      "value": "”"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Kostnadsförslag"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "” betyder en ungefärlig prisuppgift för den Sjukvårdande behandlingen som Evidensia lämnar till Hästägaren/Beställaren i samband med Inskrivningen."
    }
  ],
  "J2tn32": [
    {
      "type": 0,
      "value": "Tyvärr har något gått fel. Vänligen försök vid ett senare tillfälle"
    }
  ],
  "J6AIi7": [
    {
      "type": 0,
      "value": "Ett fel uppstod när din plats skulle hämtas"
    }
  ],
  "KBojtB": [
    {
      "type": 0,
      "value": "Telefonnummer krävs"
    }
  ],
  "KbN9l8": [
    {
      "type": 0,
      "value": "Se prisinformation på vår webbplats under "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "\"Priser\""
        }
      ],
      "type": 8,
      "value": "pricesLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "L26XQU": [
    {
      "type": 0,
      "value": "Välj en annan klinik"
    }
  ],
  "L6ID4a": [
    {
      "type": 0,
      "value": "Adress krävs"
    }
  ],
  "Lj4b+u": [
    {
      "type": 0,
      "value": "Ange din e-postadress"
    }
  ],
  "LtLbS2": [
    {
      "type": 0,
      "value": "Du måste vara minst 18 år"
    }
  ],
  "M/DGFF": [
    {
      "type": 0,
      "value": "Dina uppgifter"
    }
  ],
  "MbYUIO": [
    {
      "type": 0,
      "value": "För att lösa detta kan du:"
    }
  ],
  "N/1f86": [
    {
      "type": 0,
      "value": "Telefonnumret du angav är inte giltigt"
    }
  ],
  "NmI5fB": [
    {
      "type": 0,
      "value": "Ras"
    }
  ],
  "OMbXig": [
    {
      "type": 0,
      "value": "Namn"
    }
  ],
  "OTjx7h": [
    {
      "type": 0,
      "value": "Något gick fel"
    }
  ],
  "OZc0Dg": [
    {
      "type": 0,
      "value": "Välj tjänst"
    }
  ],
  "OiFGuz": [
    {
      "type": 0,
      "value": "Inga sökresultat"
    }
  ],
  "Oj0iQH": [
    {
      "type": 0,
      "value": "Adress"
    }
  ],
  "P4eWiS": [
    {
      "type": 0,
      "value": "E-post"
    }
  ],
  "POBzNN": [
    {
      "type": 0,
      "value": "Identifiera dig för att boka"
    }
  ],
  "Qlxw7J": [
    {
      "type": 0,
      "value": "Husdjursdetaljer"
    }
  ],
  "R2Y70i": [
    {
      "type": 0,
      "value": "Ange ditt mobilnummer"
    }
  ],
  "R7Y2Go": [
    {
      "type": 0,
      "value": "Vilken typ av djur är ditt husdjur?"
    }
  ],
  "S2gCCL": [
    {
      "type": 0,
      "value": "Berätta vad ditt husdjur behöver hjälp med. Vänligen ange även ditt husdjurs kön och ålder."
    }
  ],
  "S6hFuf": [
    {
      "type": 0,
      "value": "Boka klinikbesök"
    }
  ],
  "SHAwNy": [
    {
      "type": 0,
      "value": "LÄS OCH GODKÄNN"
    }
  ],
  "SSJQtP": [
    {
      "type": 0,
      "value": "Du måste vara minst 18 år för att registrera dig och boka online. Kontakta kliniken för hjälp."
    }
  ],
  "SwYEPV": [
    {
      "type": 0,
      "value": "Kön"
    }
  ],
  "T4E2Fv": [
    {
      "type": 0,
      "value": "Försök igen!"
    }
  ],
  "TRDtyo": [
    {
      "type": 0,
      "value": "Logga in"
    }
  ],
  "TaZfZ3": [
    {
      "type": 0,
      "value": "Om du inte hittar bokningsbar tid för ditt ärende, vänligen kontakta oss på "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "number"
        }
      ],
      "type": 8,
      "value": "phoneNumber"
    }
  ],
  "ThaO7S": [
    {
      "type": 0,
      "value": "Ja"
    }
  ],
  "Tk09uv": [
    {
      "type": 0,
      "value": "Vad heter ditt djur?"
    }
  ],
  "UNgv4x": [
    {
      "type": 0,
      "value": "Eftermiddag"
    }
  ],
  "Uo14SK": [
    {
      "children": [
        {
          "type": 0,
          "value": "Allmänt"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": Evidensia ersätter Djurägaren endast för skada som orsakats av vårdslöshet eller försummelse vid utförandet av den Sjukvårdande behandlingen, dock inte indirekt skada. Evidensia ersätter inte förlust, skada eller utebliven vinst i näringsverksamhet. Ersättning enligt ovan betalas med ett högsta belopp om ett (1) prisbasbelopp (vid var tid gällande enligt socialförsäkringsbalken), om inte något annat anges i dessa Allmänna villkor. Evidensia ersätter inte Djurägaren för skada till följd av att Djurägaren använder, eller förlitar sig på, ett besiktningsprotokoll för något annat syfte än det syfte som angavs i samband med Inskrivningen."
    }
  ],
  "VJHGax": [
    {
      "type": 0,
      "value": "Villkor godkända"
    }
  ],
  "VNdtgp": [
    {
      "type": 0,
      "value": "månader"
    }
  ],
  "VkqHcN": [
    {
      "type": 0,
      "value": "Mejla oss på "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "supportEmail"
        }
      ],
      "type": 8,
      "value": "link"
    },
    {
      "type": 0,
      "value": ", så återkommer vi så snart som möjligt."
    }
  ],
  "VzXPY/": [
    {
      "type": 0,
      "value": "Mobil"
    }
  ],
  "WHuzIz": [
    {
      "type": 0,
      "value": "Du använder en webbläsare som inte stöds. Vänligen öppna denna webbplats i din standardwebbläsare, som Chrome eller Safari."
    }
  ],
  "WWEZX6": [
    {
      "type": 0,
      "value": "Försök igen"
    }
  ],
  "WoIxoP": [
    {
      "type": 0,
      "value": "Födelsedatum"
    }
  ],
  "Wyk0Yt": [
    {
      "children": [
        {
          "type": 0,
          "value": "Profylaktisk behandling på initiativ av Hästägaren/Beställaren"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": Evidensia ersätter inte skada till följd av profylaktisk behandling som utförts på initiativ av Hästägaren/Beställaren om Evidensia dessförinnan har avrått Hästägaren/ Beställaren från behandlingen."
    }
  ],
  "XDTgUs": [
    {
      "type": 0,
      "value": "Försök igen"
    }
  ],
  "XVF6up": [
    {
      "type": 0,
      "value": "Försäkringsnummer"
    }
  ],
  "XcOpbS": [
    {
      "type": 0,
      "value": "Uppdatera mobilnummer"
    }
  ],
  "Xl2OHD": [
    {
      "type": 0,
      "value": "Logga ut"
    }
  ],
  "Y294VV": [
    {
      "type": 0,
      "value": "Inställningar"
    }
  ],
  "YDTA5Q": [
    {
      "type": 0,
      "value": "Välj en art för ditt husdjur"
    }
  ],
  "YWqIuX": [
    {
      "type": 0,
      "value": "”"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Beställaren"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "” betyder en person som är minst 18 år och som har ansvar för hästen som den Sjukvårdande behandlingen avser vid Inskrivningen, antingen i egenskap av att själv vara Hästägare eller enligt fullmakt från Hästägaren."
    }
  ],
  "Yvnih+": [
    {
      "type": 0,
      "value": "Användare hittades inte"
    }
  ],
  "Z7fqEE": [
    {
      "type": 0,
      "value": "Visa kliniker nära mig"
    }
  ],
  "ZFx66U": [
    {
      "type": 0,
      "value": "Något gick fel"
    }
  ],
  "a5fQrr": [
    {
      "type": 0,
      "value": "Vill du välja en specifik vårdgivare?"
    }
  ],
  "a8I10Q": [
    {
      "type": 0,
      "value": "Kontaktuppgifter"
    }
  ],
  "a8h+Yh": [
    {
      "type": 0,
      "value": "Stad krävs"
    }
  ],
  "bXn7lI": [
    {
      "children": [
        {
          "type": 0,
          "value": "Profylaktisk behandling på initiativ av Djurägaren"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": Evidensia ersätter inte skada till följd av profylaktisk behandling som utförts på initiativ av Djurägaren om Evidensia dessförinnan har avrått Djurägaren från behandlingen."
    }
  ],
  "beujhJ": [
    {
      "type": 0,
      "value": "Mobilt BankID"
    }
  ],
  "cOcLsR": [
    {
      "type": 0,
      "value": "När ditt djur behöver vård, hjälper vi med litet som stort"
    }
  ],
  "cPbREX": [
    {
      "type": 0,
      "value": "Vänligen fyll i anteckningarna"
    }
  ],
  "cvhTTu": [
    {
      "type": 0,
      "value": "Inloggning misslyckades"
    }
  ],
  "d8n5n5": [
    {
      "children": [
        {
          "type": 0,
          "value": "”Sjukvårdande behandling” betyder"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " varje åtgärd som vidtas för att medicinskt förebygga, påvisa, lindra eller bota sjukdom, skada eller därmed jämförligt tillstånd hos djur; åtgärder för att utföra operativa ingrepp på eller ge injektioner till djur i annat fall; inklusive, men inte begränsat till, besiktningar av och utlåtanden om djurs status, hälsa eller därmed jämförbart tillstånd."
    }
  ],
  "dRMELz": [
    {
      "type": 0,
      "value": "E-post"
    }
  ],
  "dnPxQW": [
    {
      "type": 0,
      "value": "”"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Evidensia"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "” betyder det Dotterbolag inom Evidensia Djursjukvård AB, org. Nr 556880-7217, som utför den Sjukvårdande behandlingen."
    }
  ],
  "eR7nsN": [
    {
      "type": 0,
      "value": "Hoppsan! Den här sidan finns inte."
    }
  ],
  "eYsKny": [
    {
      "children": [
        {
          "type": 0,
          "value": "Besiktning"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ": Om den Sjukvårdande behandlingen utgörs av besiktning av djurets status, hälsa eller därmed jämförbart tillstånd ska Evidensia i samband med Inskrivningen anteckna syftet med besiktningen. Syftet kommer vara avgörande för nivån och omfattningen av besiktningen. Djurägaren är medveten om att en besiktning alltid utgör en ögonblicksbedömning och en subjektiv värdering."
    }
  ],
  "f2BPDb": [
    {
      "type": 0,
      "value": "Ange stad, postnummer..."
    }
  ],
  "fRA8IF": [
    {
      "type": 0,
      "value": "Försäkringsgivare"
    }
  ],
  "gFpun4": [
    {
      "type": 0,
      "value": "Postnummer krävs"
    }
  ],
  "gOPXE6": [
    {
      "type": 0,
      "value": "Boka klinikbesök"
    }
  ],
  "gclMyN": [
    {
      "type": 0,
      "value": "Kontaktuppgifter"
    }
  ],
  "ghblYR": [
    {
      "type": 0,
      "value": "Försök igen!"
    }
  ],
  "h3bTRM": [
    {
      "type": 0,
      "value": "Boka för ett annat djur"
    }
  ],
  "iSyUA/": [
    {
      "type": 0,
      "value": "Genom att godkänna bekräftar du att du har läst och accepterar villkoren"
    }
  ],
  "jA1SyB": [
    {
      "type": 0,
      "value": "Välkommen"
    },
    {
      "type": 1,
      "value": "newLine"
    },
    {
      "type": 1,
      "value": "name"
    }
  ],
  "jJhhUG": [
    {
      "type": 0,
      "value": "Avbryt"
    }
  ],
  "jXyZqz": [
    {
      "type": 0,
      "value": "”"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Kostnadstak"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "” betyder uppgift om den högsta kostnaden för den Sjukvårdande behandlingen som Evidensia, vid Hästägaren/Beställarens förfrågan, lämnar till Hästägaren/Beställaren i samband med Inskrivningen."
    }
  ],
  "jnMZTV": [
    {
      "type": 0,
      "value": "Mer info"
    }
  ],
  "k+3605": [
    {
      "type": 0,
      "value": "Dölj detaljer"
    }
  ],
  "kAqHc0": [
    {
      "type": 0,
      "value": "Inget kvar att göra här! Du har redan godkänt våra "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "allmänna villkor"
        }
      ],
      "type": 8,
      "value": "tosLink"
    },
    {
      "type": 0,
      "value": " inför ditt besök."
    }
  ],
  "kHCY5B": [
    {
      "type": 0,
      "value": "”"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Hästägaren"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "” betyder en person som är minst 18 år och som äger hästen som den Sjukvårdande behandlingen avser."
    }
  ],
  "kIi12/": [
    {
      "type": 0,
      "value": "Logga ut"
    }
  ],
  "l8lO/0": [
    {
      "type": 0,
      "value": "Telefonnumret är för kort"
    }
  ],
  "lRhA7i": [
    {
      "type": 0,
      "value": "Försäkringsbolag"
    }
  ],
  "lTcTd0": [
    {
      "type": 0,
      "value": "Försök igen!"
    }
  ],
  "larG61": [
    {
      "type": 0,
      "value": "Välkommen "
    },
    {
      "type": 1,
      "value": "name"
    }
  ],
  "m4dnTD": [
    {
      "type": 0,
      "value": "Något gick fel"
    }
  ],
  "mMWP1r": [
    {
      "type": 0,
      "value": "Stad"
    }
  ],
  "mcaPp/": [
    {
      "type": 0,
      "value": "”"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Inskrivning"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "” betyder det förfarande genom vilket Djurägaren registrerar sitt djur hos Evidensia i anslutning till den Sjukvårdande behandlingen. ”Kostnadsförslag” betyder en ungefärlig prisuppgift för den Sjukvårdande behandlingen som Evidensia lämnar till Djurägaren i samband med Inskrivningen."
    }
  ],
  "miQryU": [
    {
      "type": 0,
      "value": "”"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Evidensia"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "” betyder ett bolag (i) som direkt eller indirekt kontrollerar Evidensia; (ii) som är under samma direkta eller indirekta ägande eller kontroll som Evidensia; eller (iii) som direkt eller indirekt ägs eller kontrolleras av Evidensia. I det här sammanhanget ska ett bolag anses vara kontrollerat av någon annan om det andra bolaget äger mer än femtio procent (&gt;50%) av rösterna i ett sådant bolag, kan styra bolagets angelägenheter eller kontrollera styrelsens, eller motsvarande organs, sammansättning av styrelseledamöter eller motsvarande."
    }
  ],
  "mz0/QX": [
    {
      "type": 0,
      "value": "Försök igen"
    }
  ],
  "nCaFya": [
    {
      "type": 0,
      "value": "Innan vi kan undersöka ditt djur eller ge behandling behöver vi ditt godkännande av våra villkor. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Vänligen läs igenom nedan och godkänn"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " före besöket hos oss."
    }
  ],
  "njiUl3": [
    {
      "type": 0,
      "value": "På så sätt kan vi se om du är ny eller återkommande kund och anpassa din bokningsupplevelse därefter."
    }
  ],
  "o6MBsr": [
    {
      "type": 0,
      "value": "BankID på annan enhet"
    }
  ],
  "oIhAbm": [
    {
      "type": 0,
      "value": "Om du inte hittar den tjänst du söker, vänligen kontakta oss på "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "clinicPhoneNumber"
        }
      ],
      "type": 8,
      "value": "clinicPhoneNumberText"
    }
  ],
  "oKvvWS": [
    {
      "type": 0,
      "value": "Tack för ditt godkännande! Du har alltid åtkomst till våra "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "allmänna villkor"
        }
      ],
      "type": 8,
      "value": "tosLink"
    },
    {
      "type": 0,
      "value": " på vår hemsida."
    }
  ],
  "oO87cD": [
    {
      "type": 0,
      "value": "Ja, välj vårdgivare"
    }
  ],
  "od7cXt": [
    {
      "type": 0,
      "value": "Du kan avboka ditt besök senast 24 timmar innan. Uteblivet besök debiteras."
    }
  ],
  "oeM2VM": [
    {
      "type": 0,
      "value": "Godkännande av allmänna villkor för smådjur"
    }
  ],
  "pB8SjL": [
    {
      "type": 0,
      "value": "Telefonnumret är för långt"
    }
  ],
  "pK+h9Q": [
    {
      "type": 0,
      "value": "Något gick fel"
    }
  ],
  "pKBkbP": [
    {
      "type": 0,
      "value": "Något gick fel!"
    }
  ],
  "pQJao5": [
    {
      "type": 0,
      "value": "Hur kan vi hjälpa dig?"
    }
  ],
  "pnF/9H": [
    {
      "type": 0,
      "value": "Något gick fel"
    }
  ],
  "qPJe3H": [
    {
      "type": 0,
      "value": "Uppdatera E-post"
    }
  ],
  "qSSaPW": [
    {
      "type": 0,
      "value": "Postnummer"
    }
  ],
  "qTE/PL": [
    {
      "type": 0,
      "value": "Namn"
    }
  ],
  "qYD8AK": [
    {
      "type": 0,
      "value": "Uppdatera försäkringsbolag"
    }
  ],
  "qa/1La": [
    {
      "type": 0,
      "value": "Vem är bokningen för?"
    }
  ],
  "qdUnYJ": [
    {
      "type": 0,
      "value": "år"
    }
  ],
  "qw1K8n": [
    {
      "type": 0,
      "value": "JAG GODKÄNNER"
    }
  ],
  "qzFV1H": [
    {
      "type": 0,
      "value": "”"
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Kostnadstak"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "” betyder uppgift om den högsta kostnaden för den Sjukvårdande behandlingen som Evidensia, vid Djurägarens förfrågan, lämnar till Djurägaren i samband med Inskrivningen"
    }
  ],
  "rIfma1": [
    {
      "type": 0,
      "value": "Inloggning misslyckades"
    }
  ],
  "s6azUm": [
    {
      "type": 0,
      "value": "Uppdatera husdjursras"
    }
  ],
  "sFmNxA": [
    {
      "type": 0,
      "value": "Uppdatera E-post"
    }
  ],
  "t9egKK": [
    {
      "type": 0,
      "value": "(Frivillig)"
    }
  ],
  "tAIqPC": [
    {
      "type": 0,
      "value": "månad"
    }
  ],
  "tdFh9U": [
    {
      "type": 0,
      "value": "Djurets namn"
    }
  ],
  "uFmv01": [
    {
      "type": 0,
      "value": "Något gick fel, vänligen försök igen senare."
    }
  ],
  "uGMKxR": [
    {
      "type": 0,
      "value": "Bekräfta"
    }
  ],
  "uH7eR5": [
    {
      "type": 0,
      "value": "Inga lediga tider, välj ett annat datum"
    }
  ],
  "uRoKGW": [
    {
      "type": 0,
      "value": "Hoppsan!"
    }
  ],
  "v+MoUK": [
    {
      "type": 0,
      "value": "Uppdatera försäkringsnummer"
    }
  ],
  "v2562G": [
    {
      "type": 0,
      "value": "Försäkringsdetaljer"
    }
  ],
  "vBD/H0": [
    {
      "type": 0,
      "value": "Uppdatera kastreringsstatus"
    }
  ],
  "vtnjuG": [
    {
      "type": 0,
      "value": "Ringa oss på "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "phoneNumber"
        }
      ],
      "type": 8,
      "value": "link"
    },
    {
      "type": 0,
      "value": " för snabb hjälp"
    }
  ],
  "wAgZ+4": [
    {
      "type": 0,
      "value": "(Obligatorisk)"
    }
  ],
  "wtJ+yD": [
    {
      "type": 0,
      "value": "Välj djur"
    }
  ],
  "wyrlLZ": [
    {
      "type": 0,
      "value": "Bekräfta"
    }
  ],
  "xXiurs": [
    {
      "type": 1,
      "value": "distance"
    },
    {
      "type": 0,
      "value": " km"
    }
  ],
  "xyXEtx": [
    {
      "type": 0,
      "value": "Mikrochip"
    }
  ],
  "y2+tOy": [
    {
      "type": 1,
      "value": "label"
    },
    {
      "type": 0,
      "value": ": "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "value"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "yKRUFV": [
    {
      "type": 0,
      "value": "Välj datum och tid"
    }
  ],
  "ysoTKU": [
    {
      "type": 0,
      "value": "år"
    }
  ],
  "z0tayl": [
    {
      "type": 0,
      "value": "Djurtyp"
    }
  ],
  "z5tCw3": [
    {
      "type": 0,
      "value": "Något gick fel"
    }
  ],
  "zDOf+o": [
    {
      "type": 0,
      "value": "Försäkringsnr"
    }
  ],
  "zkaOOo": [
    {
      "type": 0,
      "value": "Din tid är nu bokad. Vi ser fram emot att se dig och ditt djur snart."
    }
  ]
}
